import { PageLayout } from '~components/page/PageLayout';
import useLabels from '~hooks/useLabels';

export default function ForbiddenPage() {
  const { hlPageForbidden, msgPageForbidden } = useLabels(['hlPageForbidden', 'msgPageForbidden']);

  return (
    <PageLayout className="page--forbidden" noHeader>
      <div className="h-screen flex flex-col gap-2 items-center justify-center font-sans">
        <div className="text-8xl font-bold">403</div>
        <div className="text-lg font-bold">{hlPageForbidden}</div>
        <div className="text-sm w-1/2 max-w-md text-center">{msgPageForbidden}</div>
      </div>
    </PageLayout>
  );
}
